const labelOf = (amount) => `$${amount.toLocaleString('en-US')}`

export const flatFeeMenuItems = ({ options, current } = {}) => {
  const amounts = [...(options || [])]
  const saved = Number(current)
  if (saved > 0 && !amounts.includes(saved)) amounts.push(saved)

  return amounts
    .sort((a, b) => a - b)
    .map(amount => ({ label: labelOf(amount), value: amount }))
}
